import React from 'react';
import {
  CardContent, CardHeader, Grid, Skeleton
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const localizedMenuStyles = makeStyles(() => createStyles({
  skeletonTile: {
    borderRadius: '8px',
    marginBottom: '46px'
  }
}));

const LocalizedMenuSkeleton = (): JSX.Element => (
  <Grid data-testid="localized-menu-skeleton-loaders">
    <CardHeader
      title={<Skeleton variant="text" height={36} width={119} />}
    />
    <CardContent>
      {
          Array.from({ length: 7 }, (_, k) => (
            <Skeleton
              key={k}
              variant="rectangular"
              width="70%"
              height={138}
              className={localizedMenuStyles().skeletonTile}
            />
          ))
        }
    </CardContent>

  </Grid>
);

export default LocalizedMenuSkeleton;
